import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { useLocaleOptions } from "../../../l10n/useLocaleOptions.ts";
import type { localeEffectBuilder } from "./localeEffectBuilder";

const Container = styled.div``;

const Title = styled.span``;

const Value = styled.span<{ $status: "selected" | "fetching" | "not-selected" }>`
  color: ${({ $status, theme }) => ($status === "selected" ? theme.secondary : theme.generalTextIconVariant)};

  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  font-style: ${({ $status }) => ($status !== "not-selected" ? "normal" : "italic")};
`;

export const LocaleEffectSummary: typeof localeEffectBuilder.views.summary = ({ config: { locale } }) => {
  const formatMessage = useFormatMessage(formatStrings);
  const options = useLocaleOptions();

  const label = options.find(({ value }) => value === locale)?.label;

  const status = label ? "selected" : "not-selected";

  return (
    <Container>
      <Title>{formatMessage("changeLocaleTo")}</Title>{" "}
      <Value $status={status}>{label ?? formatMessage("notSelected")}</Value>
    </Container>
  );
};

const formatStrings = {
  changeLocaleTo: {
    en: "Change locale to",
  },
  notSelected: {
    en: "not selected...",
  },
};
